import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from 'react-query';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { AppDataProvider } from './contexts/AppDataContext';
// import { NotificationService } from './components/notifications';
import Dashboard from './pages/Dashboard';
import MembersPage from './pages/members/MembersPage';
import SubscriptionsPage from './pages/subscriptions/SubscriptionsPage';
import EquipmentPage from './pages/equipment/EquipmentPage';
import PaymentsPage from './pages/payments/PaymentsPage';
import SessionsPage from './pages/sessions/SessionsPage';
import SettingsPage from './pages/settings/SettingsPage';
import WorkoutPlansPage from './pages/workouts/WorkoutPlansPage';
import DataBackupPage from './pages/DataBackupPage';
import BenefitsPage from './pages/benefits/BenefitsPage';
import StockPage from './pages/stock/StockPage';
import EmployeesPage from './pages/employees/EmployeesPage';
import InvoicingPage from './pages/invoicing/InvoicingPage';
import Layout from './components/layout/Layout';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <LanguageProvider>
          <ThemeProvider>
            <AppDataProvider>
              <Router>
                <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
                  <Layout>
                    <Routes>
                      <Route path="/" element={<Navigate to="/dashboard" replace />} />
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route path="/members/*" element={<MembersPage />} />
                      <Route path="/subscriptions/*" element={<SubscriptionsPage />} />
                      <Route path="/equipment/*" element={<EquipmentPage />} />
                      <Route path="/payments/*" element={<PaymentsPage />} />
                      <Route path="/sessions/*" element={<SessionsPage />} />
                      <Route path="/workouts/*" element={<WorkoutPlansPage />} />
                      <Route path="/benefits/*" element={<BenefitsPage />} />
                      <Route path="/stock/*" element={<StockPage />} />
                      <Route path="/employees/*" element={<EmployeesPage />} />
                      <Route path="/invoicing/*" element={<InvoicingPage />} />
                      <Route path="/backup" element={<DataBackupPage />} />
                      <Route path="/settings/*" element={<SettingsPage />} />
                    </Routes>
                  </Layout>
                  <Toaster
                    position="top-right"
                    toastOptions={{
                      className: 'bg-white/90 backdrop-blur-sm border border-white/20 shadow-xl',
                      style: {
                        background: 'rgba(255, 255, 255, 0.9)',
                        backdropFilter: 'blur(12px)',
                        border: '1px solid rgba(255, 255, 255, 0.2)',
                      },
                    }}
                  />
                </div>
              </Router>
            </AppDataProvider>
          </ThemeProvider>
        </LanguageProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App; 